export default "__VITE_ASSET__BonJu0Vn__"